<template>
<div class="query">
  <div class="detailQuery">
    <div class="queryTop">
      <div class="queryTop-back">
        <div class="iconfont iconzuojiantou jian" @click="gobackWallet"></div>
        <div>提现</div>
        <div></div>
      </div>

      <div class="queryTop-searchCont">
        <div></div>
        <div class="wantDraw" @click="wantDraw">我要提现</div>
      </div>

      <div class="queryTop-moneyCont">
        <span>￥</span>
        <span>{{totalAmount}}</span>
      </div>
      <div class="queryTop-moneyNo">平安银行电子账户余额</div>
    </div>
  </div>

  <div class="queryBottom">
      <div class="money-list" v-for="item in incomeList" :key="item.id">
        <div class="money-list-left">
          <div class="list-left-type">
            <span class="left-type-img" v-if="item.payFlag===1"><img :src="shouru" alt=""></span>
            <span class="left-type-img" v-else><img :src="tixian2" alt=""></span>
            <span v-if="item.payFlag===1">发生类型:收入</span>
            <span v-else>发生类型:提现</span>
          </div>
          <div class="list-left-date">{{item.createdAt}}</div>
        </div>
        <div class="money-list-right">{{item.transAmount}}</div>
      </div>
  </div>
  <div class="no-shu" v-if="incomeList.length==0">
    <div class="shu">暂无数据</div>
  </div>

  <!-- 分页 -->
  <div class="footer" v-if="incomeList.length!==0">
    <van-pagination v-model="formData.currentPage" :total-items="pageCount" mode="simple" @change="fetchAccountList" />
  </div>
  <div>

  </div>
</div>
</template>
<script>
import http from "../../../api/index.js";
import config from "../../../utils/config";
export default {
  data(){
    return{
      shouru:require("../../../assets/img/shouru.png"),
      tixian2:require("../../../assets/img/tixian2.png"),
      formData:{
        accountId:"",
        currentPage: 1,
	      pageSize: 10
      },
      incomeList:[],
      totalAmount:"",
      pageCount:0,
    }
  },
  mounted(){
    this.myWalletDedail()
  },
  methods:{
    myWalletDedail(){
      http.post(config.myWallet).then(({code,data,message})=>{ 
        if(code===0){
          console.log(data.myAccount.accountId)
          this.totalAmount=data.totalAmount;
          this.formData.accountId=data.myAccount.accountId;
          console.log(this.formData)
          this.accountRecord()
        }else{
          this.$toast.fail(message)
        }
      })
    },

    accountRecord(){
      http.post(config.accountRecord,this.formData).then(({code,data,message})=>{
        if(code===0){
          this.incomeList=data.rows;
          this.pageCount=data.count;
        }else{
          this.$toast.fail(message)
        }     
      })
    },
    fetchAccountList(){
      this.accountRecord()
    },
    gobackWallet(){
      this.$router.go(-1)
    },
    wantDraw(){
      this.$router.push({path:"/checkDetail"})
    },
  }  
}
</script>
<style lang="less" scoped>
.query{
  height: 100%;
  background: #f8f8f8;
     .detailQuery{
     width:100%;
     height: 338px;
     background: url("../../../assets/img/bjtop.png") no-repeat;
     background-size: contain;
     .queryTop{
       .queryTop-back{
         padding: 30px 20px;
         display: flex;
         justify-content: space-between;
         align-items: center;
         color: #ffffff;
         font-size: 35px;
         .jian{
           font-size: 35px;
         }
       }
       .queryTop-searchCont{
         display: flex;
         justify-content: space-between;
         padding: 0 20px;
         font-size: 24px;
         color: #ffffff;
         .wantDraw{
           width: 133px;
           height: 48px;
           color: #1161f2;
           background: #ffffff;
          //  opacity: 0.3;
           border-radius: 24px;
           text-align: center;
           line-height: 48px;
         }
       }
       .queryTop-moneyCont{
         color: #ffffff;
         font-size: 60px;
         margin-bottom: 10px;
       }
       .queryTop-moneyNo{
         color: #ffffff;
         font-size: 26px;
       }
     }
    }

    .queryBottom{
    text-align: left;
    padding-bottom: 45px;
    .money-list{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 20px;
      height: 100px;
      margin-top: 20px;
      background: #ffffff;
      .money-list-left{
        .list-left-type{
          text-align: left;
          font-size: 32px;
          position: relative;
          .left-type-img-tixian{
            position: absolute;
            top:6px;
            left: 1px;
            img{
              width: 30px;
              height: 30px;
            }
          }
          .left-type-img{
            img{
              width: 30px;
              height: 30px;
            }
          }
        }
        .list-left-date{
          text-align: left;
          font-size: 26px;
          color: #999999;
          margin-top: 6px;
        }

      }
      .money-list-right{
        font-size: 32px;


      }
    }
  }
  .no-shu{
    padding: 150px 0;
    font-size: 50px;
    color: #bbbbbb;
  }
  .footer{
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #ffffff;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/wallet/detailQuery/index.vue